export default "__VITE_ASSET__f956677f__"